var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvertenciaTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109.205,
    height: 125,
    viewBox: "0 0 109.205 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Advertencia_02",
    "data-name": "Advertencia 02",
    transform: "translate(54.603 62.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shield2",
    transform: "translate(-54.603 -62.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6573",
    "data-name": "Trazado 6573",
    d: "M49.666,29.966H61.354L59.932,72.851H51.116Zm.64,62.388V81.891H60.993V92.354Zm56.64-73.075a205.829,205.829,0,0,1,2.259,29.966c0,53.768-43.525,72.238-52.145,75.334A10.712,10.712,0,0,1,54.6,125a9.409,9.409,0,0,1-2.456-.421C43.333,121.287,0,102.817,0,49.245A210.226,210.226,0,0,1,2.872,14.761a7.452,7.452,0,0,1,3.073-4.715C10.463,6.974,24.021,0,54.6,0s44.138,6.974,48.633,10.047a3.771,3.771,0,0,1,1.422,1.226l-7.815,3.489c-5.327-2.68-17.857-7.394-42.267-7.394-28.91.027-41.019,6.585-44.311,8.647A217.2,217.2,0,0,0,7.591,49.053c0,48.628,39.4,65.484,47.206,68.356,7.591-2.872,47.018-19.7,47.018-68.356a187.911,187.911,0,0,0-1.843-26.482Z",
    fill: "#1a1446"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertenciaTwo);
export default __webpack_public_path__ + "static/media/advertenciaTwo.33a26f1993ebfe3368a7c951b61904e1.svg";
export { ForwardRef as ReactComponent };